<template>
  <div class="homeleft">
    <div class="listai">
      <h1>
        关于姓氏的20个冷知识
      </h1>
      <Row justify="center" class="titleTime">
        <Col class="titleName" :xs="12" :sm="12" :md="12" :lg="12">作者：姓名图谱官方</Col>
        <Col class="titleName" :xs="12" :sm="12" :md="12" :lg="12">时间：2020年1月1日</Col>
      </Row>
      <p></p>
      <p>11月7日，首届中华姓氏申遗大会在福州举行，两百余名专家代表与会，推动中华姓氏申报“世界记忆遗产”。你想过，有一天自己的姓氏也能申遗吗？关于姓氏，你真的了解吗？小编为你整理了20个关于姓氏的冷门知识，快来看看。 </p>
      
      <div class="contentImg"> 
        <img src="@/assets/nameabout.jpg" />
      </div>
      <p>1、中国有23813个姓氏，目前在用姓氏共计6150个。</p>
      <p>2、“百家姓”占全国户籍人口总量的近85%。</p>
      <p>3、姓王的人最多，其次是李、张、刘、陈。（关注新浪微博@姓名图谱话题#每日一姓#）</p>
      <p>4、笔画最少的姓为“一”，由乙姓衍化而来。</p>
      <p>5、笔画最多的姓有30笔，即“爨”，读作cuàn</p>
      <p>6、字数最多的姓是藏族十字姓“伙尔川扎木苏他尔只多”。</p>
      <p>7、“柴米油盐酱醋茶”、“红绿赤橙青蓝紫”分别都是姓。</p>
      <p>8、2018年，有110万人同时使用父姓和母姓。</p>
      <p>9、台湾姓陈、林的人最多，其次是黄、张、李、王、吴、刘、蔡、杨。</p>
      <p>10、死、尿、操、毒、宰父、是、党、胖、别、粘、羊舌、母、仇、黑、苟、牛、吴、老、贾、提、宫、史、朱、李，被网友评为最难起名姓氏。</p>
      <p>11、十二生肖作为姓氏依然存在，但已经很罕见，很多人改姓，猴改候，狗改苟，蛇改畲。</p>
      <p>12、 “姓”与“氏”最早是两回事，秦汉时期，姓氏合二为一。</p>
      <p>13、“姓”是母系氏族社会的产物，上古八姓都带女字旁：姬、姚、妫、姒、姜、嬴、姞、妘。</p>
      <p>14、“氏”则是从“姓”中衍生的分支，姓贵而氏贱。</p>
      <p>15、父系氏族时期，姓氏地位反了过来。天子有姓而无氏，诸侯、卿大夫有姓有氏，平民、奴隶只有名，无姓无氏。</p>
      <p>16、有的姓来源于国家、封地、住地，如夏、周、鲁、崔、东门、西门。</p>
      <p>17、王、公、侯、司空、司马、上官一开始是爵位官职的名称。</p>
      <p>18、很多姓经过简化，如拓跋改为元，耶律氏改姓萧，辛亥革命后原满族贵族改为赵、金、关三姓。</p>
      <p>19、秦以后，赐姓成为天子表彰功臣、为其加官进爵的重要方式，如郑和。</p>
      <p>20、不用“免贵”的姓氏有三个，张、孔，以及所在朝代皇帝的姓氏。</p>
      <p style="text-align:center; font-size:13px; color:#ccc;">资料来源：《中华姓氏大辞典》，《二〇一八年全国姓名报告》</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: []
    };
  }
};
</script>

<style scoped lang="scss">
.homeleft {
  .contentImg {
      text-align: center;
      img {
        width: 600px;
      }
      @media screen and(max-width:1200px) {
        img {
          width: 300px;
        }
      }
    }
  .listai {
    @media screen and(max-width:1200px) {
      padding: 0px;
    }
    padding: 16px;
    h1 {
      margin: 30px 0;
      text-align: center;
      @media screen and(max-width:1200px) {
        margin: 10px 0;
      }
    }
    h3 {
      color: #00d2a5;
      // text-align: center;
    }
    h4 {
      font-size: 16px;
      // text-indent: 8px;
    }
    h5 {
      font-size: 15px;
      text-indent: 14px;
    }
    .titleTime {
      height: 80px;
      line-height: 80px;
      border-bottom: 1px #e8eaec solid;
      .titleName {
        color: #00d2a5;
        text-align: center;
      }
    }
    p {
      @media screen and(max-width:1200px) {
        padding: 5px;
      }
      padding: 10px 20px;
      font-size: 15px;
      text-indent: 28px;
      line-height: 28px;
    }

  }
}
</style>
